import {trackEventSP} from "js/studios/shared/tracking"

export class HorizontalScroller {
  static selector = "[data-component=horizontal-scroller]"

  constructor(el) {
    this.root = el
    this.content = el.querySelector(".horizontal-scroller__items")

    this.setupEventListeners()
  }

  get scrollPerClick() {
    return Math.max(
      this.content.getBoundingClientRect().width * 0.3,
      this.content.querySelector(":first-child").getBoundingClientRect().width,
    )
  }

  scrollX(xDelta) {
    trackEventSP("click_scroll_in_scroll_slideshow", "browse")
    if (xDelta < 0 && Math.abs(xDelta) > this.content.scrollLeft) {
      xDelta = 0 - this.content.scrollLeft
    }
    this.content.scrollBy({top: 0, left: xDelta, behavior: "smooth"})
  }

  setupEventListeners() {
    this.root.querySelector(".horizontal-scroller__controls [data-action=left]").addEventListener("click", ev => {
      ev.preventDefault()
      this.scrollX(-1 * this.scrollPerClick)
    })
    this.root.querySelector(".horizontal-scroller__controls [data-action=right]").addEventListener("click", ev => {
      ev.preventDefault()
      this.scrollX(this.scrollPerClick)
    })
  }
}
